import React from 'react';
import styled from 'styled-components';
import AchievementPanel from './AchievementPanel';

interface AchievementsModalProps {
  isVisible: boolean;
  onClose: () => void;
  modeId: string;
}

const Overlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(4px);
  z-index: 1300;
  display: ${p => p.$isVisible ? 'flex' : 'none'};
  align-items: flex-end;
  justify-content: center;
  @media (min-width: 769px) {
    align-items: center;
  }
`;

const Sheet = styled.div`
  --am-text: var(--theme-text,#f5f5f5);
  --am-bg: var(--theme-card-background,#1c1f24);
  background: var(--am-bg);
  color: var(--am-text);
  width: 100%;
  max-width: 560px;
  max-height: 85vh;
  border-radius: 20px 20px 0 0;
  padding: 30px 28px 38px;
  box-shadow: 0 -4px 24px rgba(0,0,0,0.55);
  overflow-y: auto;
  @media (min-width: 769px) {
    border-radius: 20px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--am-text);
`;

const CloseBtn = styled.button`
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.2);
  width: 44px; height: 44px;
  border-radius: 12px;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  color: var(--am-text);
  display:flex; align-items:center; justify-content:center;
  transition: background .2s;
  &:hover { background: rgba(255,255,255,0.15); }
`;

const AchievementsModal: React.FC<AchievementsModalProps> = ({ isVisible, onClose, modeId }) => {
  return (
    <Overlay $isVisible={isVisible} onClick={onClose}>
      <Sheet onClick={e => e.stopPropagation()}>
        <Header>
          <Title>🎖 Achievements</Title>
          <CloseBtn aria-label="Stäng" onClick={onClose}>×</CloseBtn>
        </Header>
        <AchievementPanel modeId={modeId} />
      </Sheet>
    </Overlay>
  );
};

export default AchievementsModal;
